import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class BookingConfigService {

    constructor(private router: Router, private titleService: Title) { }

    private configs = {
        flygets: {
            site: 'flygets',
            baseUrl: '/parkifly/flygets',
            hmr: false,
            IDENTITY: environment.IDENTITY,
            orgId: 'a848ccd3-fd8d-4035-925e-571ebb4e93e8',
            discountCode: 'NONE',
            searchSelect: 'advanced',
            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: true,
                    flight: true,
                },
                detailsFields: {
                    luggage: true,
                },
                confirmation: {
                    pdf: true,
                }
            },
            // additionalServices: true,
            freeShuttles: true
        },
        skavsta: {
            site: 'skavsta',
            baseUrl: '/parkifly/skavsta',
            hmr: false,
            IDENTITY: environment.IDENTITY,
            orgId: 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B',
            discountCode: 'NONE',
            searchSelect: 'simple',
            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: false,
                    flight: false,
                },
                detailsFields: {
                    luggage: false,
                },
                confirmation: {
                    pdf: true,
                }
            },
            // additionalServices: false,
            freeShuttles: false
        },
        mdpark: {
            site: 'mdpark',
            baseUrl: '/parkifly/mdpark',
            IDENTITY: environment.IDENTITY,
            CJHUB: JSON.stringify('/'),
            mapbox: {
                accessToken:
                    'pk.eyJ1IjoibW9sbmRyaWZ0IiwiYSI6ImNram9hbG0yczJrOWgyenFvYmhpZWtna2UifQ.RDUPgFliWdqFBJwT_x9uGw'
            },
            appInsights: {
                instrumentationKey: 'f7c7b021-39a2-47d1-be38-05c65421b4fe'
            },
            orgId: 'D9EB0AF8-5B3D-4281-8725-372E2D6A7804',
            discountCode: 'NONE',
            searchSelect: 'advanced',
            // additionalServices: false,
            freeShuttles: false,

            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: true,
                    flight: true,
                },
                detailsFields: {
                    luggage: true,
                },
                confirmation: {
                    pdf: true,
                }
            }
        },
        nazar: {
            site: 'nazar',
            baseUrl: '/parkifly/nazar',
            hmr: false,
            IDENTITY: environment.IDENTITY,
            orgId: 'a848ccd3-fd8d-4035-925e-571ebb4e93e8',
            targetOrgId: '3868EF69-054C-40BD-93AE-85CF08E4C71F',
            discountCode: 'nazar',
            searchSelect: 'advanced',
            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: true,
                    flight: true,
                },
                detailsFields: {
                    luggage: true,
                },
                confirmation: {
                    pdf: true,
                }
            },
            // additionalServices: true,
            freeShuttles: true
        },
        tui: {
            site: 'tui',
            baseUrl: '/parkifly/tui',
            hmr: false,
            IDENTITY: environment.IDENTITY,
            orgId: 'a848ccd3-fd8d-4035-925e-571ebb4e93e8',
            targetOrgId: '2868EF69-054C-40BD-93AE-85CF08E4C71F',
            discountCode: 'TUI10',
            searchSelect: 'advanced',
            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: true,
                    flight: true,
                },
                detailsFields: {
                    luggage: true,
                },
                confirmation: {
                    pdf: true,
                }
            },
            // additionalServices: true,
            freeShuttles: true
        },
        'quality-xpo-arlanda': {
            site: 'quality-xpo-arlanda',
            baseUrl: '/parkifly/quality-xpo-arlanda',
            hmr: false,
            IDENTITY: environment.IDENTITY,
            orgId: '942ce067-7848-4441-b746-8f6eed7395bb',
            discountCode: 'NONE',
            searchSelect: 'simple',
            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: false,
                    flight: false,
                },
                detailsFields: {
                    luggage: false,
                },
                confirmation: {
                    pdf: true,
                }
            },
            // additionalServices: true,
            freeShuttles: true
        },
        'quality': {
            site: 'quality',
            baseUrl: '/parkifly/parking-and-transfer/quality',
            hmr: false,
            IDENTITY: environment.IDENTITY,
            orgId: '942ce067-7848-4441-b746-8f6eed7395bb',
            shuttleOrgId: '39218780-069A-4C6B-9925-22365A075C15',
            discountCode: 'NONE',
            searchSelect: 'parking-and-transfer',
            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: true,
                    flight: true,
                },
                detailsFields: {
                    luggage: true,
                },
                confirmation: {
                    pdf: true,
                }
            },
            // additionalServices: true,
            freeShuttles: true
        },
        'aiden-short-term': {
            site: 'aiden-short-term',
            baseUrl: '/parkifly/aiden-short-term',
            hmr: false,
            IDENTITY: environment.IDENTITY,
            orgId: '55D7084D-3CF0-4CCC-9448-F924AFCDF3BC',
            discountCode: 'NONE',
            searchSelect: 'simple',
            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: false,
                    flight: false,
                },
                detailsFields: {
                    luggage: false,
                },
                confirmation: {
                    pdf: true,
                }
            },
            freeShuttles: true
        },
        'aiden': {
            site: 'aiden',
            baseUrl: '/parkifly/aiden-parkandfly',
            hmr: false,
            IDENTITY: environment.IDENTITY,
            orgId: '55D7084D-3CF0-4CCC-9448-F924AFCDF3BC',
            shuttleOrgId: 'D6B9D8C6-8FB5-41A5-AC2E-B3FC007A8251',
            discountCode: 'NONE',
            searchSelect: 'parking-and-transfer',
            options: {
                psfInfoCard: {
                    parking: true,
                    transfer: true,
                    flight: true,
                },
                detailsFields: {
                    luggage: true,
                },
                confirmation: {
                    pdf: true,
                }
            },
            freeShuttles: true
        }
    };

    private validOrgs = ['flygets', 'skavsta', 'mdpark', 'nazar', 'tui', 'quality-xpo-arlanda', 'quality-xpo-arlanda-parkandfly', 'quality', 'aiden-parkandfly', 'parking-and-transfer', 'aiden-short-term', 'aiden'];
    private selectedOrg: string = 'flygets';

    async setOrganization(org: string): Promise<void> {
        if (this.validOrgs.includes(org)) {
            this.selectedOrg = org;
            localStorage.setItem('selectedOrganization', org);
        } else {
            console.warn(`Invalid organization: ${org}`);
            this.selectedOrg = 'flygets';
            localStorage.setItem('selectedOrganization', 'flygets');
        }

        const orgTitles: Record<string, string> = {
            flygets: 'Flygets',
            skavsta: 'Skavsta',
            mdpark: 'MD Park',
            nazar: 'Nazar',
            tui: 'TUI',
            'quality-xpo-arlanda': 'Quality Hotel',
            quality: 'Quality',
            aiden: 'Aiden',
            'aiden-short-term': 'Aiden',
        };

        const title = orgTitles[org] || 'Parkifly';
        this.titleService.setTitle(title);
    }

    async setOrganizationFromUrl(): Promise<void> {
        const url = this.router.url;

        if (url.includes('/simple-widget-booking')) {
            this.selectedOrg = 'skavsta';
            this.titleService.setTitle('Skavsta');
            localStorage.setItem('navigation_organization', 'DC3E5C36-A4F7-4886-98F2-4833EA27F84B');
            localStorage.setItem('selectedOrganization', 'skavsta');
            return;
        }
        if (url.includes('/advanced-widget-booking')) {
            this.selectedOrg = 'flygets';
            this.titleService.setTitle('Flygets');
            localStorage.setItem('navigation_organization', 'A848CCD3-FD8D-4035-925E-571EBB4E93E8');
            localStorage.setItem('selectedOrganization', 'flygets');
            return;
        }
        if (url.includes('/park-and-fly-advanced-widget-booking')) {
            this.selectedOrg = 'quality';
            this.titleService.setTitle('Quality');
            localStorage.setItem('navigation_organization', '942ce067-7848-4441-b746-8f6eed7395bb');
            localStorage.setItem('selectedOrganization', 'quality');
            return;
        }
        if (url.includes('/aiden-park-and-fly-advanced-widget-booking')) {
            this.selectedOrg = 'aiden';
            this.titleService.setTitle('Aiden');
            localStorage.setItem('navigation_organization', '55D7084D-3CF0-4CCC-9448-F924AFCDF3BC');
            localStorage.setItem('selectedOrganization', 'aiden');
            return;
        }
        if (url.includes('/app-short-term-widget')) {
            this.selectedOrg = 'quality-xpo-arlanda';
            this.titleService.setTitle('Quality Hotel');
            localStorage.setItem('navigation_organization', '942ce067-7848-4441-b746-8f6eed7395bb');
            localStorage.setItem('selectedOrganization', 'quality-xpo-arlanda');
            return;
        }
        if (url.includes('/app-aiden-short-term-widget')) {
            this.selectedOrg = 'aiden-short-term';
            this.titleService.setTitle('Aiden');
            localStorage.setItem('navigation_organization', '55D7084D-3CF0-4CCC-9448-F924AFCDF3BC');
            localStorage.setItem('selectedOrganization', 'aiden-short-term');
            return;
        }

        const urlSegments = this.router.url.split('/');

        if (urlSegments[1] === 'parkifly' || urlSegments[1] === 'parkifly-new') {

            let orgFromUrl;
            let orgName;
            orgFromUrl = urlSegments[2]?.split('?')[0];
            orgName = urlSegments[3]?.split('?')[0];
            let finalOrg = 'flygets';

            if (this.validOrgs.includes(orgFromUrl)) {

                if (orgFromUrl === 'quality-xpo-arlanda-parkandfly' || orgFromUrl === 'aiden-parkandfly' || orgFromUrl === 'parking-and-transfer') {
                    if (orgFromUrl === 'parking-and-transfer') {
                        if (orgName === 'aiden') {
                            finalOrg = 'aiden';
                        }
                        else if (orgName === 'quality') {
                            finalOrg = 'quality';
                        }
                    }
                    else if (orgFromUrl === 'aiden-parkandfly') {
                        finalOrg = 'aiden';
                    } else {
                        finalOrg = 'quality';
                    }
                    localStorage.setItem('selectedOrganization', finalOrg);
                }
                else {
                    finalOrg = orgFromUrl;
                    localStorage.setItem('selectedOrganization', orgFromUrl);
                }
            } else {
                const saved = localStorage.getItem('selectedOrganization');
                if (this.validOrgs.includes(saved)) {
                    finalOrg = saved;
                }
                localStorage.setItem('selectedOrganization', finalOrg);
            }

            this.selectedOrg = finalOrg;

            const orgTitles: Record<string, string> = {
                flygets: 'Flygets',
                skavsta: 'Skavsta',
                mdpark: 'MD Park',
                nazar: 'Nazar',
                tui: 'TUI',
                'quality-xpo-arlanda': 'Quality Hotel',
                quality: 'Quality',
                aiden: 'Aiden',
                'aiden-short-term': 'Aiden'
            };

            const title = orgTitles[finalOrg] || 'Parkifly';
            this.titleService.setTitle(title);

        } else {
            const orgFromUrl = urlSegments[1]?.split('?')[0];
            if (orgFromUrl === 'tui' || orgFromUrl === 'nazar') {
                this.selectedOrg = orgFromUrl;
                localStorage.setItem('selectedOrganization', orgFromUrl);

                const orgTitles: Record<string, string> = {
                    nazar: 'Nazar',
                    tui: 'TUI'
                };

                const title = orgTitles[orgFromUrl];
                this.titleService.setTitle(title);
            } else {
                this.selectedOrg = 'flygets';
                this.titleService.setTitle('Flygets Långtidsparkering');
                localStorage.setItem('selectedOrganization', "flygets");
            }

        }
    }

    getConfig() {
        return this.configs[this.selectedOrg];
    }
}
